import { Component, Input, NgModule } from '@angular/core';
import { features } from 'src/app/shared/helpers/tenant.features';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ScreenService } from 'src/app/shared/services/screen.service';
import { DirectModule } from 'src/app/shared/components/direct/direct.module';
import { UserService } from 'src/app/shared/services/user/user.service';

@Component({
  selector: 'app-medigi-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
})
export class MedigiFooterComponent {
  @Input() loggedIn: boolean = false;
  @Input() directBlackBox: any;
  @Input() isBuyer: boolean = false;

  mobileUser;
  copyrightYear;
  readonly features = features;

  constructor(
    private screenSize: ScreenService,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    this.mobileUser =
      this.screenSize.sizes['screen-small'] === true ||
      this.screenSize.sizes['screen-x-small'] === true;
    this.copyrightYear = new Date().getFullYear();

    if (this.loggedIn) {
      this.userService
        .getMe()
        .subscribe(user => (this.isBuyer = user.data.is_buyer));
    }
  }

  goToSocials(link) {
    window.open(link, '_blank');
  }
}

@NgModule({
  imports: [CommonModule, RouterModule, DirectModule],
  declarations: [MedigiFooterComponent],
  exports: [MedigiFooterComponent],
})
export class MedigiFooterModule {}
